import { create } from 'zustand';
import type { Node, Connection } from '../types';

interface SelectionState {
  selectedNode: Node | null;
  selectedNodes: string[];
  hoveredNode: string | null;
  selectedConnection: Connection | null;
  revealedFlashcards: Record<string, boolean>;

  setSelectedNode: (node: Node | null) => void;
  setSelectedNodes: (ids: string[] | ((prev: string[]) => string[])) => void;
  setHoveredNode: (id: string | null) => void;
  setSelectedConnection: (conn: Connection | null) => void;
  setRevealedFlashcards: (revealed: Record<string, boolean> | ((prev: Record<string, boolean>) => Record<string, boolean>)) => void;
}

export const useSelectionStore = create<SelectionState>()((set) => ({
  selectedNode: null,
  selectedNodes: [],
  hoveredNode: null,
  selectedConnection: null,
  revealedFlashcards: {},

  setSelectedNode: (selectedNode) => set({ selectedNode }),
  setSelectedNodes: (arg) =>
    set((s) => ({
      selectedNodes: typeof arg === 'function' ? arg(s.selectedNodes) : arg,
    })),
  setHoveredNode: (hoveredNode) => set({ hoveredNode }),
  setSelectedConnection: (selectedConnection) => set({ selectedConnection }),
  setRevealedFlashcards: (arg) =>
    set((s) => ({
      revealedFlashcards: typeof arg === 'function' ? arg(s.revealedFlashcards) : arg,
    })),
}));
